import { UseControllerProps } from 'react-hook-form';

export const INSURANCE_NUMBER_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[0-9\W_]+$/,
    message: 'شماره بیمه نامعتبر است',
  },
};
